import { render, staticRenderFns } from "./CoursePackagesDetails.vue?vue&type=template&id=0c0429ea&scoped=true"
import script from "./CoursePackagesDetails.vue?vue&type=script&lang=js"
export * from "./CoursePackagesDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0429ea",
  null
  
)

export default component.exports